import axios from "axios";
import 'bootstrap/js/dist/modal';
import $ from "jquery";
import {removeActiveBackdrop} from "./modal-backdrop";
import {switchModalScreen} from "./switch-screen"

export const renderModal = (link, modalSelector, modalScreenSelector) => {
    axios.get(link)
        .then((response) => {
            modalInitialize(response.data, modalSelector, '#modal-block', modalScreenSelector);
            bindModalCloseEvents(modalSelector);
        });
};

export const modalInitialize = (response, modalSelector, parentBlock, modalScreenSelector ) => {
    $(parentBlock).html(response);

    if (modalScreenSelector !== undefined) {
        switchModalScreen(modalScreenSelector);
    }

    $(modalSelector).modal();
};

export const bindModalCloseEvents = (modalSelector, customFunc) => {
    $(modalSelector + ' .modal-close').on("click", function () {
        modalCloseEvents(modalSelector, customFunc);
    });
};

export const modalCloseEvents = (modalSelector, customFunc) => {
    removeActiveBackdrop();

    $.when($(modalSelector).modal('hide'))
        .then(() => {
            $(modalSelector).remove();

            if (customFunc !== undefined) {
                customFunc();
            }
        });
};
